(function() {
  'use strict';

  angular
    .module('iqxCore')
    .service('switchesSvc', switchesSvc)

  function switchesSvc(ApplicationSvc){
    var svc = this
    svc.check = check

    ///////////

    function check(switches){
      var type = Object.prototype.toString.call(switches)
      if(type === "[object String]"){
        if(switches[0]==="!"){
          return !ApplicationSvc.currentUser.Switches.indexOf(switches.substring(1).toUpperCase()) > -1
        }else{
          return ApplicationSvc.currentUser.Switches.indexOf(switches.toUpperCase()) > -1
        }
      }else if(type === '[object Array]'){
        var arrayLength = switches.length
        for(var i = 0; i < arrayLength; i++){
          if(switches[i][0]==="!"){
            if(ApplicationSvc.currentUser.Switches.indexOf(switches[i].substring(1).toUpperCase()) !== -1){
              return false
            }
          }else{
            if(ApplicationSvc.currentUser.Switches.indexOf(switches[i].toUpperCase()) === -1){
              return false
            }
          }
        }
        return true
      }else{
        throw new Error('Parameter switches must be of type string or array')
      }
    }

  }

})()